const subUsersValidationHR = {
    "add": {
        "first_name": {
            "required": "Ime je obavezno"
        },
        "last_name": {
            "required": "Prezime je obavezno"
        },
        "email": {
            "required": "Email je obavezan",
            "invalid": "Email nije valjan",
            "unique": "Email je povezan s drugim korisnikom"
        },
        "username": {
            "required": "Korisničko ime je obavezno",
            "stringCaseLower": "Korisničko ime mora biti malim slovima",
            "regexp": "Korisničko ime mora sadržavati samo slova i brojeve",
            "unique": "Korisničko ime je povezano s drugim korisnikom",
            "invalid": "Korisničko ime nije valjano"
        },
        "password": {
            "required": "Lozinka je obavezna",
            "regexp": "Lozinka mora imati najmanje 10 znakova, uključujući 1 veliko slovo i 1 poseban znak"
        },
        "confirmPassword": {
            "required": "Molimo potvrdite lozinku",
            "identical": "Vrijednosti lozinke i potvrde lozinke moraju se podudarati"
        },
        "contract_expiry": {
            "required": "Datum isteka ugovora je obavezan"
        },
        "sub_user_deal": {
            "required": "Dogovor s podkorisnikom je obavezan",
            "between": "Dogovor s podkorisnikom mora biti između 0 i 100"
        },
        "street_and_number": {
            "required": "Ulica i kućni broj su obavezni"
        },
        "postal_code": {
            "required": "Poštanski broj je obavezan"
        },
        "city": {
            "required": "Grad je obavezan"
        },
        "country": {
            "required": "Država je obavezna"
        },
        "phone": {
            "required": "Telefonski broj je obavezan"
        }
    },
    "update": {
        "first_name": {
            "required": "Ime je obavezno"
        },
        "last_name": {
            "required": "Prezime je obavezno"
        },
        "email": {
            "required": "Email je obavezan",
            "invalid": "Email nije valjan"
        },
        "username": {
            "required": "Korisničko ime je obavezno",
            "stringCaseLower": "Korisničko ime mora biti malim slovima",
            "regexp": "Korisničko ime mora sadržavati samo slova i brojeve"
        },
        "contract_expiry": {
            "required": "Datum isteka ugovora je obavezan"
        },
        "sub_user_deal": {
            "required": "Dogovor s podkorisnikom je obavezan",
            "between": "Dogovor s podkorisnikom mora biti između 0 i 100"
        },
        "street_and_number": {
            "required": "Ulica i kućni broj su obavezni"
        },
        "postal_code": {
            "required": "Poštanski broj je obavezan"
        },
        "city": {
            "required": "Grad je obavezan"
        },
        "country": {
            "required": "Država je obavezna"
        },
        "phone": {
            "required": "Telefonski broj je obavezan"
        }
    }
};

export default subUsersValidationHR;